import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M38.603 10.103a.5.5 0 1 0-.708-.707L24.5 22.792v-9.48a.5.5 0 0 0-1 0V24a.5.5 0 0 0 .5.5h10.687a.5.5 0 1 0 0-1h-9.48l13.396-13.396ZM9.75 12.813a.5.5 0 0 0-.5.5v24.935a.5.5 0 0 0 .5.5h24.936a.5.5 0 0 0 .5-.5v-9.796a.5.5 0 1 0-1 0v9.296H10.25V13.812h10.187a.5.5 0 1 0 0-1H9.75Z",
      clipRule: "evenodd"
    }
  )
);
var SvgMinimizeOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MinimizeOutlined_default = SvgMinimizeOutlined;

export { MinimizeOutlined_default as default };
